module.exports = __webpack_public_path__ + "img/es-ct.e6db39f3.svg";